import React from "react";

import styles from "./ProductCard.module.scss";
import { Link } from "react-router";

interface ProductCardProps {
  img: string;
  title: string;
  colors: string;
  price: number;
  isFavorite?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ img, title, colors, price, isFavorite }) => {
  const [count, setCount] = React.useState(0);

  return (
    <div className={styles.item}>
      <div className={styles.favorites}>
        <svg width="31" height="29" viewBox="0 0 31 29" fill="none">
          <path
            d="M16.337 26.4886C15.878 26.6504 15.122 26.6504 14.663 26.4886C10.748 25.1538 2 19.5853 2 10.1471C2 5.98077 5.3615 2.60999 9.506 2.60999C11.963 2.60999 14.1365 3.7965 15.5 5.63021C16.1936 4.69431 17.097 3.93366 18.1379 3.40919C19.1788 2.88472 20.3282 2.61101 21.494 2.60999C25.6385 2.60999 29 5.98077 29 10.1471C29 19.5853 20.252 25.1538 16.337 26.4886Z"
            fill="white"
            stroke="#1C1D20"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className={styles.image}>
        <img src={img} alt="content" />
        <div className={styles.materials}>100%полиэстер</div>
      </div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.colors}>{colors}</p>
      <div className={styles.other}>
        <p className={styles.price}>{`${price} р.`}</p>
        {isFavorite ? (
          <div className={styles.isFavorites}>
            <svg width="31" height="29" viewBox="0 0 31 29" fill="none">
              <path
                d="M16.337 26.4886C15.878 26.6504 15.122 26.6504 14.663 26.4886C10.748 25.1538 2 19.5853 2 10.1471C2 5.98077 5.3615 2.60999 9.506 2.60999C11.963 2.60999 14.1365 3.7965 15.5 5.63021C16.1936 4.69431 17.097 3.93366 18.1379 3.40919C19.1788 2.88472 20.3282 2.61101 21.494 2.60999C25.6385 2.60999 29 5.98077 29 10.1471C29 19.5853 20.252 25.1538 16.337 26.4886Z"
                fill="#FF3281"
                stroke="#1C1D20"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>Избранное</p>
          </div>
        ) : (
          <div className={styles.block}>
            <div className={styles.buttons}>
              <span onClick={() => setCount((prev) => (prev > 0 ? prev - 1 : 0))}>-</span>
              <p className={styles.count}>{count}</p>
              <span onClick={() => setCount((prev) => prev + 1)}>+</span>
            </div>
            <button>
              <Link to="/product">Купить</Link>
            </button>
            <div className={styles.favoritesMobile}>
              <svg width="31" height="29" viewBox="0 0 31 29" fill="none">
                <path
                  d="M16.337 26.4886C15.878 26.6504 15.122 26.6504 14.663 26.4886C10.748 25.1538 2 19.5853 2 10.1471C2 5.98077 5.3615 2.60999 9.506 2.60999C11.963 2.60999 14.1365 3.7965 15.5 5.63021C16.1936 4.69431 17.097 3.93366 18.1379 3.40919C19.1788 2.88472 20.3282 2.61101 21.494 2.60999C25.6385 2.60999 29 5.98077 29 10.1471C29 19.5853 20.252 25.1538 16.337 26.4886Z"
                  fill="white"
                  stroke="#1C1D20"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>Избранное</p>
            </div>
          </div>
        )}
        <button className={styles.buy}>
          <Link to="/product">Купить</Link>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
